module.exports = __webpack_public_path__ + "static/img/07.eed4774.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/znhy/07.jpg
// module id = NcuR
// module chunks = 1